import { Component, Input } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MasterDetailListEntry } from '@sdbn/common';
import { DocumentTemplateDetails, SelectDefinition, SelectOption } from '../../document-template-administration-model';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'app-template-lookup-editor',
    templateUrl: './template-lookup-editor.component.html',
    styleUrls: ['./template-lookup-editor.component.scss'],
    standalone: false
})
export class TemplateLookupEditorComponent {

  template = null;

  selectedDefinition: SelectDefinition;
  selectedOption: SelectOption;

  selectDefinitionFormGroup: FormGroup;

  @Input("template") set setTemplate(template: DocumentTemplateDetails) {
    this.template = template;
    if (template.selectDefinitions.length > 0) {
      this.onSelectionChanged(template.selectDefinitions[0]);
    }
  }

  constructor() {

    this.selectDefinitionFormGroup = new FormGroup({
      identifier: new FormControl('', [Validators.required]),
    });

    this.selectDefinitionFormGroup.valueChanges.subscribe(
      v => {

        if (this.selectedDefinition != null && this.selectDefinitionFormGroup.dirty) {
          this.selectedDefinition.identifier = this.selectDefinitionFormGroup.controls.identifier.value;
          this.template.dirty = true;
          this.template.validate();
        }

      }
    );
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    if (entry instanceof SelectDefinition) {
      this.selectedDefinition = entry as SelectDefinition;
      this.selectedOption = this.selectedDefinition?.options.length > 0 ? this.selectedDefinition?.options[0] : null;
      const values = {
        identifier: this.selectedDefinition.identifier
      };
      this.selectDefinitionFormGroup.reset(values);
    }
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {

    let selectDefinition = new SelectDefinition();
    selectDefinition.uuid = uuidv4();
    this.template.selectDefinitions.push(selectDefinition);

    this.onSelectionChanged(selectDefinition);

  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    const index = this.template.selectDefinitions.indexOf(entry as SelectDefinition, 0);
    if (index > -1) {
      this.template.selectDefinitions.splice(index, 1);
    }
    // TODO Dirty flag && selection aktualisieren
  }

}
